import { cn } from "../ui/index.ts";
import * as React from "react";
import type { Patient } from "../../core/services/patients.service.ts";
import { patientNameParts } from "./patient-name.ts";
import { patientPhotoUrl } from "./patient-photo.ts";

type PatientLike = Pick<Patient, "uuid" | "name" | "color" | "photoUrl">;

function initialsFromName(name: string): string {
  const { first, last } = patientNameParts(name);
  if (last && first) {
    return `${last[0]}${first[0]}`.toUpperCase();
  }
  return name
    .split(" ")
    .map((n) => n[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function PatientAvatar({
  patient,
  size = 32,
  className,
  ring,
  online,
}: {
  patient: PatientLike;
  size?: number;
  className?: string;
  ring?: boolean;
  online?: boolean;
}) {
  const [failed, setFailed] = React.useState(false);
  const src = patient.photoUrl ?? patientPhotoUrl(patient.uuid);
  const initials = initialsFromName(patient.name);

  return (
    <span
      className={cn("relative inline-flex shrink-0", className)}
      style={{ width: size, height: size }}
    >
      {failed ? (
        <span
          className={cn(
            "flex size-full items-center justify-center rounded-full font-semibold text-white",
            ring && "shadow-[0_0_0_2px_white,0_0_0_3px_var(--sf-border)]",
          )}
          style={{
            background: patient.color,
            fontSize: Math.max(10, size * 0.34),
          }}
        >
          {initials}
        </span>
      ) : (
        <img
          src={src}
          alt=""
          width={size}
          height={size}
          className={cn(
            "block size-full rounded-full object-cover",
            ring && "shadow-[0_0_0_2px_white,0_0_0_3px_var(--sf-border)]",
          )}
          onError={() => setFailed(true)}
        />
      )}
      {online && (
        <span className="absolute -bottom-px -right-px h-2.5 w-2.5 rounded-full border-2 border-white bg-sf-success" />
      )}
    </span>
  );
}
